export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/fYnBHJqLX5NbkpvjvzszU1/ChatGPT-Image-28-jul-2026_-08_40_19-p.m..webp'

export const CHECKOUT_URL =
  'https://terapista-occupazionale-pro.impultienda.ar/checkout'

export const PRODUCT_NAME = 'TERAPISTA OCCUPAZIONALE PRO™'
